import SEO from '@/components/base/SEO';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import HeroSection from './components/HeroSection';
import CategoryGrid from './components/CategoryGrid';
import ArticleGrid from './components/ArticleGrid';
import TestimonialSection from './components/TestimonialSection';
import CTASection from './components/CTASection';

export default function Home() {
  const websiteSchema = {
    '@context': 'https://schema.org',
    '@type': 'WebSite',
    name: '51在线吃瓜网',
    url: 'http://jnjiu.cn' + ('' || ''),
    description: '51在线吃瓜网为您提供今日吃瓜入口，每日更新网红黑料、吃瓜大赛、最新爆料视频，实时追踪网络热点事件，吃瓜群众在线观看不迷路。',
    potentialAction: {
      '@type': 'SearchAction',
      target: {
        '@type': 'EntryPoint',
        urlTemplate: 'http://jnjiu.cn' + ('' || '') + '/search?q={search_term_string}',
      },
      'query-input': 'required name=search_term_string',
    },
  };

  const orgSchema = {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: '51在线吃瓜网',
    url: 'http://jnjiu.cn' + ('' || ''),
    description: '全网最专业的吃瓜导航，每日更新网红黑料、最新爆料视频',
    contactPoint: {
      '@type': 'ContactPoint',
      telephone: '400-888-5151',
      contactType: 'customer service',
      email: 'hello@jnjiu.cn',
    },
  };

  return (
    <>
      <script type="application/ld+json">{JSON.stringify(websiteSchema)}</script>
      <script type="application/ld+json">{JSON.stringify(orgSchema)}</script>
      <SEO
        title="51在线吃瓜网 - 51在线吃瓜今日吃瓜入口 | 网红黑料每日吃瓜大赛 最新爆料视频实时更新中"
        description="51在线吃瓜网为您提供今日吃瓜入口，每日更新网红黑料、吃瓜大赛、最新爆料视频，实时追踪网络热点事件，吃瓜群众在线观看不迷路。"
        keywords="51在线吃瓜网,51在线吃瓜今日吃瓜入口,网红黑料,每日吃瓜大赛,最新爆料视频,实时更新,51吃瓜爆料,51吃瓜在线观看"
        canonicalUrl="/"
      />
      <Navbar />
      <main>
        <HeroSection />
        <CategoryGrid />
        <ArticleGrid />
        <CTASection />
        <TestimonialSection />
      </main>
      <Footer />
    </>
  );
}